import axios from 'axios';
import { SECURITY_HEADER } from '../constants';

/**
 * Create an Axios Client with defaults
 */
const client = axios.create({
  baseURL: process.env.REACT_APP_CORE_API_URL 
});

/**
 * Request Wrapper with default success/error actions
 */
const httpRequest = function(options, anonymous = false, baseURL = process.env.REACT_APP_CORE_API_URL) {

  client.defaults.baseURL = baseURL;

  const onSuccess = function(response) {
    console.debug('Request Successful!', response);
    return response.data;
  }

  const onError = function(error) {
    console.error('Request Failed:', error.config);

    if (error.response) {
      // Request was made but server responded with something
      // other than 2xx
      console.error('Status:',  error.response.status);
      console.error('Data:',    error.response.data);
      console.error('Headers:', error.response.headers);

    } else {
      // Something else happened while setting up the request
      // triggered the error
      console.error('Error Message:', error.message);
    }

    return Promise.reject(error.response || error.message);
  }

  options.headers = {};
  options.headers[SECURITY_HEADER] = process.env.REACT_APP_CORE_API_SECURITY_KEY ;

  return client(options)
            .then(onSuccess)
            .catch(onError);
}

export default httpRequest;